/*
Despliega el cuadro con los datos de la organizacion
*/

export interface OrganizationFrameType {
  nin?: string
  phone?: string
  email?: string
  domain?: string
  address?: string
  name?: string
  business?: string
  user?: { name: string; phone: string }
}
import { useFeatureFlag } from '../hooks/useFeatureFlag'

import { OrganizationFrame as OrganizationFrameV2 } from './OrganizationFrameV2'

export const OrganizationFrame: React.FC<{ organization: OrganizationFrameType }> = ({ organization }) => {
  const { useNewDocumentUI } = useFeatureFlag()

  if (useNewDocumentUI) return <OrganizationFrameV2 organization={organization} />

  return (
    <>
      <div className="text-[1.5em]">{organization.name}</div>

      <div className="grid grid-cols-6 gap-x-2 gap-y-0">
        <div className="">Rut</div>
        <div className="col-span-2 font-bold">{organization.nin}</div>
        {/* El giro es opcional */}
        {organization.business && organization.business !== '' ? (
          <>
            <div className="">Giro</div>
            <div className="col-span-2 font-bold">{organization.business} </div>
          </>
        ) : (
          <div className="col-span-3"></div>
        )}
        <div className="">Teléfono</div>
        <div className="col-span-2 font-bold">{organization.phone}</div>
        <div className="">Email</div>
        <div className="col-span-2 font-bold">{organization.email}</div>
        <div className="">Web</div>
        <div className="col-span-5 font-bold">{organization.domain}</div>
        <div className="">Dirección</div>
        <div className="col-span-5 font-bold">{organization.address}</div>
        <div className="">Vendedor</div>
        <div className="col-span-2 font-bold">{organization.user?.name}</div>
        <div className="">Teléfono</div>
        <div className="col-span-2 font-bold">{organization.user?.phone}</div>
      </div>
    </>
  )
}
